import React, { useRef, useEffect, useContext, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ResponsiveContext } from '../../contexts/responsiveContext'
import { SearchContext } from '../../contexts/searchContext'
import styles from './styles.module.css'

const SearchInput = () => {
  const searchInput = useRef(null)
  const { t } = useTranslation()
  const { isMobile } = useContext(ResponsiveContext)
  const { query, setIsVisible, isSearchMobileActive, setIsSearchMobileActive, onChangeQuerySearch } = useContext(SearchContext)

  useEffect(() => {
    if (isSearchMobileActive) {
      searchInput.current.focus()
    }
  }, [isSearchMobileActive])

  const onClickSearchButton = useCallback(() => {
    if (isMobile) {
      setIsSearchMobileActive(!isSearchMobileActive)
    } else {
      query ? setIsVisible(true) : searchInput.current.focus()
    }
  }, [query, setIsVisible, isMobile, isSearchMobileActive, setIsSearchMobileActive])

  return (
    <div className={`${styles.searchBarGroup} ${isSearchMobileActive && styles.active}`}>
      <input
        type="text"
        ref={searchInput}
        value={query}
        className="hot-form__input"
        placeholder={t('general.search')}
        onChange={onChangeQuerySearch}
      />

      <button onClick={onClickSearchButton}>
        <FontAwesomeIcon size="1x" icon={isSearchMobileActive && isMobile ? ['far', 'times'] : ['fal', 'search']} />
      </button>
    </div>
  )
}

export default SearchInput
